export default __webpack_public_path__ + "static/media/quotationMark.21799756.svg";